<!-- Top Donors -->
<app-top-list [hidden]="checkLenth(supporters?.topDonors,5)" [donors]="supporters?.topDonors"
              title="Top Contributors"
              [isFundraiserEnded]="isFundraiserEnded"
              cardType="topDonor"
              [donateBtnLabel]="donateBtnLabel"
              [fundraiser]="fundraiser"
              icon="icon-trophy" [settings]="settings" *ngIf="view !== 'dream11'">
</app-top-list>
<!--Most Raised from Social Sharing -->
<app-top-list [hidden]="checkLenth(supporters?.mostRaisedSocial,1) || this.fundraiser?.support_campaign" [donors]="supporters?.mostRaisedSocial"
              title="Most Raised from Social Sharing"
              cardType="mostRaised"
              [fundraiser]="fundraiser"
              [isFundraiserEnded]="isFundraiserEnded"
              icon="icon-promote" [settings]="settings" type="social">
</app-top-list>
<!-- Supporters -->
<app-top-list [hidden]="checkLenth(supporters?.supporters,1)" [donors]="supporters?.supporters"
              [title]="fundraiser?.raised?.backers + ' Supporters'"
              cardType="supporters"
              [view]="view"
              [isLoading]="isLoading"
              [isFundraiserEnded]="isFundraiserEnded" [fundraiser]="fundraiser"
              icon="icon-users" [settings]="settings">
</app-top-list>
